// Copy rules for every entry in EVENT_ENTRIES:
// - The title is in Title Case: a noun followed by a past participle
//   ("Email Opened").
// - The message is one sentence in sentence case. The actor comes first, verbs
//   are lowercase, and records are links. No bold: a link or a detail label
//   provides the emphasis.
// - Secondary facts go in EntryDetails rows, which omit empty values.
// - The record type belongs in the title, never in a "Model:" line.
// - An imported entry ends with importSuffix: "via import (Data Job #N)".
import { ATTACHMENT_EVENTS } from "components/LogItem/events/attachmentEvents";
import { CALL_EVENTS } from "components/LogItem/events/callEvents";
import { CAMPAIGN_EVENTS } from "components/LogItem/events/campaignEvents";
import { CONTACT_EVENTS } from "components/LogItem/events/contactEvents";
import { EMAIL_EVENTS } from "components/LogItem/events/emailEvents";
import { FORM_EVENTS } from "components/LogItem/events/formEvents";
import { JOB_EVENTS } from "components/LogItem/events/jobEvents";
import { LEAD_EVENTS } from "components/LogItem/events/leadEvents";
import { MACHINE_EVENTS } from "components/LogItem/events/machineEvents";
import { MAIL_EVENTS } from "components/LogItem/events/mailEvents";
import { NOTE_EVENTS } from "components/LogItem/events/noteEvents";
import { RECORD_EVENTS } from "components/LogItem/events/recordEvents";
import { SWOOGO_EVENTS } from "components/LogItem/events/swoogoEvents";
import { TEXT_MESSAGE_EVENTS } from "components/LogItem/events/textMessageEvents";

export const EVENT_ENTRIES = {
  ...EMAIL_EVENTS,
  ...MAIL_EVENTS,
  ...CALL_EVENTS,
  ...TEXT_MESSAGE_EVENTS,
  ...NOTE_EVENTS,
  ...ATTACHMENT_EVENTS,
  ...FORM_EVENTS,
  ...RECORD_EVENTS,
  ...CAMPAIGN_EVENTS,
  ...CONTACT_EVENTS,
  ...JOB_EVENTS,
  ...MACHINE_EVENTS,
  ...SWOOGO_EVENTS,
  ...LEAD_EVENTS,
};
